
import { Options, Vue, prop } from "vue-class-component";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { PrintReceiptController } from "@/app/ui/controllers/PrintReceiptController";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { parsingErrorResponse } from "@/app/infrastructures/misc/Utils";
import SendInvoiceReceiverRows from "./SendInvoiceReceiverRows.vue";
import {
  Invoice,
  InvoiceDataInterface,
  Receiver
} from "@/domain/entities/PrintReceipt";
import InvoicePdfA4 from "./invoice/InvoicePdfA4.vue";
import InvoicePdfStruk from "./invoice/InvoicePdfStruk.vue";
import { getPhoneDisplayCode } from '@/app/infrastructures/misc/common-library/v2/FormatPhoneNumber';

class Props {
  show = prop<boolean>({
    type: Boolean,
    default: false
  });
  invoiceData = prop<InvoiceDataInterface>({
    type: InvoiceDataInterface,
    default: new InvoiceDataInterface()
  });
  mode = prop<string>({
    type: String,
    default: "send"
  });
}

@Options({
  components: {
    SendInvoiceReceiverRows,
    InvoicePdfA4,
    InvoicePdfStruk
  }
})
export default class ModalSendInvoice extends Vue.with(Props) {
  props: any = this.$props;

  // Modal state
  showSuccessModal = false;
  // successData: any = null;
  isLoadingSend = false;
  file = {} as File;

  // Receivers state from child component
  receiversData: any = {
    receivers: [],
    validReceivers: [],
    isValid: false
  };

  // Dropdown options
  viaOptions = [
    { name: "Email", value: "email" },
    { name: "WhatsApp", value: "whatsapp" }
  ];

  formatOptions = [
    { name: "PDF (A4)", value: "pdf_a4" },
    { name: "PNG (A4)", value: "png_a4" },
    { name: "PDF (Ukuran Struk)", value: "pdf_struk" }
  ];

  // Computed
  get accountCurrency(): "IDR" | "MYR" {
    return (
      (AccountController.accountData?.accountCurrency as "IDR" | "MYR") ?? "IDR"
    );
  }
  get modalTitle() {
    const invoiceNo = this.invoiceData?.invoiceNo || "";
    const baseTitle = this.$t("tagihan.activity.sendInvoice");
    return invoiceNo ? `${baseTitle} - ${invoiceNo}` : baseTitle;
  }

  get isDisabledSubmit() {
    return !this.receiversData.isValid;
  }

  get successData() {
    return PrintReceiptController.invoiceSuccessData;
  }

  get invoiceDetail() {
    return PrintReceiptController.invoiceDetailData;
  }

  // Methods
  onReceiversUpdate(data: any) {
    this.receiversData = data;
  }

  onCloseModal() {
    this.$emit("update:show", false);
    this.$emit("close");
  }

  async onSubmit() {
    const validReceivers = this.receiversData.validReceivers;

    if (validReceivers.length === 0) {
      return;
    }

    // Mode emit: just emit data back to parent
    if (this.mode === "emit") {
      this.$emit("submit", validReceivers);
      this.onCloseModal();
      return;
    }

    // Mode send: process send
    await this.processSend(validReceivers);
  }

  async processSend(validReceivers: Receiver[]) {
    // generate
    const pdf = await (this.$refs as any).invoice.generatePdfA4();
    const png = await (this.$refs as any).invoice.generatePngA4();
    const pdfStruk = await (this.$refs as any).struk.generatePdfStruk();

    // donwload
    if (validReceivers[0].via === "whatsapp") {
      if (validReceivers[0].format === "pdf_a4") {
        await (this.$refs as any).invoice.downloadPdfA4();
      } else if (validReceivers[0].format === "png_a4") {
        await (this.$refs as any).invoice.downloadPngA4();
      } else if (validReceivers[0].format === "pdf_struk") {
        await (this.$refs as any).struk.downloadPdfStruk();
      }
    }

    // send
    await PrintReceiptController.processSendInvoice({
      validReceivers: validReceivers,
      invoiceId: this.invoiceData?.id,
      invoiceNo: this.invoiceData?.invoiceNo,
      pdf,
      pdfStruk,
      png,
      isShowModalSuccess: true
    }).then(() => {
      this.$emit("success");
    });
  }

  formatPhone62(phone: string): string {
    if (/[^0-9]/.test(phone)) {
      return "";
    }
    const prefix = getPhoneDisplayCode(
      AccountController.accountData?.countryCode
    ).replace("+", "");
    let cleaned = phone;
    if (cleaned.startsWith("0")) {
      cleaned = prefix + cleaned.substring(1);
    }
    if (!cleaned.startsWith(prefix)) {
      cleaned = prefix + cleaned;
    }
    return cleaned;
  }

  onCloseSuccessModal() {
    this.showSuccessModal = false;
    this.onCloseModal();
    // Emit success event to parent if needed
    this.$emit("success", this.successData);
  }
}
